import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import { Thunk } from 'ha/myredux/types';
import { send as sendAlert } from 'ha/modules/Alertbar/actions';
import { reportError } from 'ha/helpers/bugsnag/reportError';
import { defineKey as T } from '@ha/intl';
import { GlobalState } from 'ha/types/store';
import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import { Actions as NavBarActions } from 'ha/modules/NavBar/actions';
import { setInStorage } from 'ha/utils/sessionStorage';

import { getFeatureFlags } from 'ha/modules/FeatureFlags';
import { UrlResolver } from 'ha/helpers/UrlResolver';
import { isLoading } from '../selectors';
import { STORAGE_KEY } from '../constants';

const ERROR_MESSAGE = T(
  'There was an error adding your favorite listing. Please try again later',
);

export enum ActionTypes {
  START = '[favorites] ADD_FAVORITE',
  DONE = '[favorites] ADD_FAVORITE_DONE',
  FAIL = '[favorites] ADD_FAVORITE_FAIL',
}

export const Actions = {
  start: (listingId: number) => createAction(ActionTypes.START, listingId),
  done: (listingId: number) => createAction(ActionTypes.DONE, listingId),
  fail: (listingId: number) => createAction(ActionTypes.FAIL, listingId),
};
export type ActionsType = ActionsUnion<typeof Actions>;

type AddFavoriteListing = (
  listingId: number,
  isTenantMULFlowEnabled: boolean,
  returnUrl?: string,
  urlResolver?: UrlResolver,
) => Thunk<GlobalState>;

export const addFavoriteListing: AddFavoriteListing =
  (listingId, isTenantMULFlowEnabled, returnUrl, urlResolver) =>
  async (dispatch, getState, { apiV2 }) => {
    const state = getState();
    if (!getIsAuthenticated(state)) {
      setInStorage(STORAGE_KEY, listingId);

      const { enableOAuthTokamak } = getFeatureFlags(state);

      if (enableOAuthTokamak === 'on') {
        if (typeof window !== 'undefined') {
          if (urlResolver) {
            window.location.href = urlResolver?.absolutizePath(
              urlResolver?.getOAuthSignupUrl(
                urlResolver?.absolutizePath(returnUrl ?? '/'),
              ),
            );
          }
        }
        return;
      }

      dispatch(NavBarActions.showModal('register', returnUrl));
      return;
    }

    if (isLoading(state, listingId)) {
      return;
    }

    dispatch(Actions.start(listingId));

    try {
      if (isTenantMULFlowEnabled) {
        await apiV2.addFavoriteUnitType(listingId);
      } else {
        await apiV2.addFavoriteListing(listingId);
      }

      dispatch(Actions.done(listingId));
    } catch (error) {
      reportError('Error adding favourite listing', { metaData: { error } });
      dispatch(
        sendAlert({
          text: ERROR_MESSAGE,
          kind: 'danger',
          dismissAfter: 5000,
        }),
      );
      dispatch(Actions.fail(listingId));
    }
  };
